var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "position-relative", attrs: { id: "chatbot-dashboard" } },
    [
      _vm.movingMode
        ? _c("MovePanel", { attrs: { changeMoveMode: _vm.changeMoveMode } })
        : _vm._e(),
      _vm._v(" "),
      _vm.copyingMode
        ? _c("CopyPanel", { attrs: { changeCopyMode: _vm.changeCopyMode } })
        : _vm._e(),
      _vm._v(" "),
      _vm.dragMode ? _c("DragPanel") : _vm._e(),
      _vm._v(" "),
      _c("DesignerMenu", {
        attrs: { automation: _vm.automation },
        on: {
          updateAutomation: function ($event) {
            return _vm.$emit("updateAutomation", $event)
          },
        },
      }),
      _vm._v(" "),
      _c("FlowBreadCrumb", {
        attrs: {
          navigateTo: _vm.navigateToBlock,
          navigation: _vm.getNavigationDetail(),
          "preview-mode": _vm.previewMode,
          automation: _vm.automation,
        },
      }),
      _vm._v(" "),
      !_vm.dragMode
        ? _c("FooterToolbar", {
            attrs: {
              scale: _vm.scale,
              "focus-start-point": _vm.focusStartPoint,
              "preview-mode": _vm.previewMode,
              automation: _vm.automation,
            },
            on: {
              updateScale: function (e) {
                return (this$1.scale = e)
              },
              toggleMinimap: _vm.handleMinimapToggle,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.block && !_vm.movingMode && !_vm.copyingMode
        ? _c("Toolbar", {
            attrs: {
              dragMode: _vm.dragMode,
              dragStart: _vm.dragStart,
              dragEnd: _vm.dragEnd,
              addBlockToDiagram: _vm.addBlockToDiagram,
              flattedDiagram: _vm.flattedDiagram,
              blocksMetas: _vm.blocksMetas,
              "preview-mode": _vm.previewMode,
              navigateTo: _vm.navigateToBlock,
              automation: _vm.automation,
              testStartBlockId: _vm.testStartBlockId,
            },
            on: {
              openModal: _vm.openModal,
              setTranslate: function (e) {
                return this$1.updateTranslate(e, true)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !!_vm.block && !_vm.movingMode && !_vm.copyingMode
        ? _c("BlockModal", {
            ref: "BlockModal",
            attrs: {
              block: _vm.block,
              flattedDiagram: _vm.flattedDiagram,
              "preview-mode": _vm.previewMode,
              automation: _vm.automation,
            },
            on: { close: _vm.closeModal },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.addMenu
        ? _c("AddContextMenu", {
            attrs: {
              addMenuPos: _vm.addMenuPos,
              block: _vm.addBlock,
              addBlockToDiagram: _vm.addBlockToDiagram,
              navigation: _vm.getNavigationDetail(),
              showNotification: _vm.showNotification,
              flattedDiagram: _vm.flattedDiagram,
              blocksMetas: _vm.blocksMetas,
              getAllowedBlocks: _vm.getAllowedBlocks,
              automation: _vm.automation,
            },
            on: { closeContextMenu: _vm.closeModal },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { overflow: "hidden" } },
        [
          _vm.overlayVisible
            ? _c("div", {
                staticClass: "overlay",
                on: {
                  click: function ($event) {
                    return _vm.closeModal(false)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("AutomationDiagramViewer", {
            ref: "automationDiagramViewer",
            attrs: {
              translate: _vm.translate,
              scale: _vm.scale,
              automation: _vm.automation,
              translating: _vm.translating,
              selectedBlock: !!_vm.block && _vm.block.id,
              navigation: _vm.getNavigationDetail(),
              navigateToBlock: _vm.navigateToBlock,
              movingMode: _vm.movingMode,
              movingBlock: _vm.movingBlock,
              changeMoveMode: _vm.changeMoveMode,
              moveBlock: _vm.moveBlock,
              copyingMode: _vm.copyingMode,
              copyingBlock: _vm.copyingBlock,
              changeCopyMode: _vm.changeCopyMode,
              copyBlock: _vm.copyBlock,
              flattedDiagram: _vm.flattedDiagram,
              showNotification: _vm.showNotification,
              dragMode: _vm.dragMode,
              addBlockToDiagram: _vm.addBlockToDiagram,
              draggingType: _vm.draggingType,
              "start-test-from-here": _vm.startTestFromHere,
              "preview-mode": _vm.previewMode,
              getAllowedBlocks: _vm.getAllowedBlocks,
            },
            on: {
              openContextMenu: _vm.openAddContext,
              updateScale: function (e) {
                return (this$1.scale = e)
              },
              updateTranslate: _vm.updateTranslate,
              setTranslate: function (e) {
                return this$1.updateTranslate(e, true)
              },
              openModal: _vm.openModal,
              blockMetasCalculated: function ($event) {
                return _vm.updateBlockMetas($event)
              },
              updateAutomation: function ($event) {
                return _vm.$emit("updateAutomation", $event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }